import $ from 'jquery';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

//vuex
import store from '../vue/store/index';

//validation
import Vuelidate from 'vuelidate'

//custom components
import flatPickr from 'vue-flatpickr-component';
import orderform from '../vue/orderForm.vue';
import ordersummary from '../vue/orderSummary.vue'
import router from '../vue/router/index.js'
import VueScrollTo from 'vue-scrollto';

//make things global
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
Vue.use(VueI18n);
Vue.use(flatPickr);
Vue.use(VueScrollTo);

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'EUR',
    },
  },
  'nl-NL': {
    currency: {
      style: 'currency', currency: 'EUR',
    },
  },
}

const i18n = new VueI18n({
  locale: 'nl-NL',
  numberFormats,
});

new Vue({
  el: '#reservationApp',
  store,
  i18n,
  router,
  components: { orderform, ordersummary },
  methods: {

    submitOrder: function(){

      const activity_name = this.$store.state.activities[this.$store.state.selected_activity].name;
      const arrangement = this.$store.state.activities[this.$store.state.selected_activity].arrangements[this.$store.state.selected_arrangement];
      const arrangement_name = arrangement.name;
      const arrangement_price = arrangement.price;

      var formdata = {

          selected_activity: activity_name,
          selected_arrangement: arrangement_name,
          selected_extras: this.$store.state.selected_extras,

          no_persons: this.$store.state.no_persons,
          reservation_date: this.$store.state.reservation_date,
          reservation_time: this.$store.state.reservation_time,

          client_name: this.$store.state.client_name,
          client_email: this.$store.state.client_email,
          client_phone: this.$store.state.client_phone,
          order_comments: this.$store.state.order_comments,

          coupon_code: this.$store.state.coupon_code,

          price_activity: arrangement_price,
          price_extras: this.$store.getters.getSelectedExtrasPrice,
          price_discount: this.$store.getters.getCouponStatus.amount,
          price_total: this.$store.getters.getOrdertotal,

          newsletter: this.$store.state.newsletter,

      };

      this.$store.dispatch('submitOrder', formdata);

    },

  },

  created() {

    const q = this.$route.query;

    this.$store.dispatch('fetchProductData').then(response => {

      if(!response){ return; }

      if(q.keuze_activiteit){
        this.$store.commit('setActivity', { activity: q.keuze_activiteit, init: true});
      }

      if(q.keuze_arrangement){
        this.$store.commit('setArrangement', q.keuze_arrangement);
      }

    });

  },

  mounted(){

    $('#formSummary').foundation();
    $('#sectionReserveForm').foundation();
  },

  computed: {

    order_status() {
      return this.$store.getters.getOrderStatus
    },

    success_message() {
      return this.$store.getters.getSuccessMessage
    },

  },

});




// WEBPACK FOOTER //
// ./scripts/vue/order.js